<template lang="pug">
  section
      b-container
        h1 NEW CORPORATE RENTAL
        b-form(@submit.prevent="submitRental")
          b-card
            b-container
              h5 Customer
              .row
                .col-6
                  b-form-group
                    label Select Customer
                    b-form-select(v-model="rentalInputForm.customer_id")
                      option(v-for="customer in customers", :value="customer.id") {{ customer.company_name }}
              p.d-inline#testP Not an existing customer?
                    b-link.m-0.text-muted.ml-2(:to="{ name: 'Customer', customerId: '' }")
                      span.mr-2 ADD NEW CUSTOMER

          b-card.mt-2
            b-container
              h5 Rental terms
              .row
                .col-md-4
                  b-form-group
                    label START DATE
                    b-form-datepicker(v-model="rentalInputForm.date_start", :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }", locale="en")
                .col-md-4
                  b-form-group
                    label CONTRACT PERIOD
                    b-form-row
                      .col-8
                        b-form-input.form-control(type='number', required, v-model='rentalInputForm.contract_period', name='contract_period', step="1", :min="1", placeholder='0')
                      .col-4
                        span months
                .col-md-4
                  b-form-group
                    label AUTO RENEW
                    b-form-checkbox(v-model='rentalInputForm.auto_renew', switch) {{ rentalInputForm.auto_renew ? 'ON' : 'OFF' }}
                .col-md-4
                  b-form-group
                    label shipping cost
                    b-form-row
                      .col-1
                        span R
                      .col-11
                        b-form-input.form-control(type='number', required, v-model='rentalInputForm.shipping_cost', step="1", :min="0", name='shipping_fee')
                .col-md-4
                  b-form-group
                    label service fee
                    b-form-row
                      .col-1
                        span R
                      .col-11
                        b-form-input.form-control(type='number', required, v-model='rentalInputForm.service_fee', step="1", :min="0", name='service_fee')
                .col-md-4
                  b-form-group
                    label discount rate
                      .form-row
                        .col-11
                          b-form-input.form-control(type='number', required, v-model='rentalInputForm.discount_percent', step="1", :min="0", name='commission_rate')
                        .col-1
                          span %
                .col-md-4
                  b-form-group(label="INSURANCE")
                    b-form-checkbox(v-model='rentalInputForm.is_insured', switch) {{ rentalInputForm.is_insured ? 'insured' : 'no insurance' }}
          b-card.mt-2
            b-container
              h5 Pieces
              .col-12
                .container
                  h4 Select pieces
                .row
                  .col-md-4
                    b-form-input(type="text", v-model="search", placeholder="search by piece or artist")
                  .col-md-6
                    b-form-select(v-model="selected")
                      option(v-for="piece in availableOptions", :value="piece") {{ `${piece.title} - ${piece.artist}` }}
                  .col-md-2
                    b-button.btn-outline(@click="addPiece") Add piece
              .col-12
                b-badge.m-1(v-for="item in rentalInputForm.items", :key="item.id")
                  span {{ item.title }}
          b-card.mt-2
            b-container
              h5 Order summary
              ul.list-unstyled
                //- li.my-1
                //-     span.font-weight-bold Customer
                //-     span.ml-1 {{ accountInputForm.company_name }}
                //- li.my-1
                //-     span.font-weight-bold From
                //-     span.ml-1 {{ rentalInputForm.date_start }}
                //- li.my-1
                //-     span.font-weight-bold contract_period
                //-     span.ml-1 {{ `${rentalInputForm.contract_period} months` }}
                li.my-1
                  span.font-weight-bold Recurring
                  span.ml-1 {{ formatRandsCents(artCost) }}
                li.my-1
                  span.font-weight-bold Shipping
                  span.ml-1 {{ formatRandsCents(rentalInputForm.shipping_cost) }}
                li.my-1
                  span.font-weight-bold Curate and install fee
                  span.ml-1 {{ formatRandsCents(rentalInputForm.service_fee) }}
                li.my-1
                  span.font-weight-bold Total
                  span.ml-1 {{ formatRandsCents(orderTotal) }}
              .m-3.text-right
                button-load(type="submit", :flag="alert.busy", label="SUBMIT", classes="btn-outline")
</template>

<script>

import { ContentLoader } from 'vue-content-loader';
import router from '@/router';
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';

export default {
  name: 'Rental',
  components: {
    ContentLoader,
  },
  mixins: [standardMix],
  data() {
    return {
      art: [],
      search: '',
      selected: null,
      customers: [],
      customerId: null,
      rentalInputForm: {
        customer_id: '',
        date_start: null,
        contract_period: '1',
        shipping_cost: 0,
        service_fee: 0,
        discount_percent: 0,
        is_insured: true,
        auto_renew: false,
        items: [
          // { product_id: 1 },
          // { product_id: 2 },
          // { product_id: 3 },
          // { product_id: 4 },
          // { product_id: 5 },
          // { product_id: 6 },
        ],
      },
      filter: {
        // artist_id: 'All',
        status: ['available'],
        // is_test: true,
      },
    };
  },
  computed: {
    availableOptions() {
      const search = this.search.toLowerCase();
      // Filter out already selected options
      // const options = this.art.filter(opt => this.value.indexOf(opt) === -1);
      if (search) {
        // Show only options that match criteria
        return this.art.filter(opt => (opt.title.toLowerCase().indexOf(search) > -1) || (opt.artist.toLowerCase().indexOf(search) > -1));
      }
      // Show all options available
      return this.art;
    },
    artCost() {
      let artCost = 0;
      // eslint-disable-next-line no-restricted-syntax
      for (const piece of this.rentalInputForm.items) {
        artCost += parseInt(piece.price_rental, 10);
      }
      const artCostDiscount = artCost * (1 - (this.rentalInputForm.discount_percent * 0.01));
      console.log(`Art Cost: ${artCost} Discounted to: ${artCostDiscount}`);
      return artCostDiscount;
    },
    orderTotal() {
      return this.artCost + parseInt(this.rentalInputForm.shipping_cost, 10) + parseInt(this.rentalInputForm.service_fee, 10);
    },
  },
  methods: {
    printDate(date) {
      this.rentalInputForm.date_start = toString(date);
    },
    async submitRental() {
      console.log({ submitting: this.rentalInputForm.date_start });

      try {
        // Add new customer
        this.clear();
        this.busy();
        await apiService.addCorporateRental({ ...this.rentalInputForm });
        this.success('Rental added');
        router.push({ name: 'Rentals' });
      } catch (error) {
        this.error(error);
      }
    },
    addPiece() {
      if (this.selected) {
        this.rentalInputForm.items.push(this.selected);
        this.selected = null;
        this.search = '';
      }
    },
  },
  async created() {
    this.loading();
    this.art = await apiService.getArt(this.filter);
    this.customers = await apiService.getCustomers({ type: ['corporate'] });
    this.clear();
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/RentalCorporateNew.vue